import { Modal, makeStyles } from "@material-ui/core";
import { Stack } from "@mui/material";
const useStyles = makeStyles((theme) => ({
  paper: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    backgroundColor: "#FFFFFF",
    borderRadius: "4px",
    boxShadow: theme.shadows[5], 
    padding: theme.spacing(4), 
    outline: 0,
    border: "1px solid #FFFFFF", 
    "@media only screen and (max-width: 600px)": {
      width: "370px",
    },
  },
}));
const BasicModal = ({ open, setOpen, children }) => {
  const classes = useStyles();
  return (
    <>
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <Stack className={classes.paper}>{children}</Stack>
      </Modal>
    </>
  );
};

export default BasicModal;
